import { render } from "./Tutoriales.vue?vue&type=template&id=ca4ce25a&scoped=true"
import script from "./Tutoriales.vue?vue&type=script&lang=js"
export * from "./Tutoriales.vue?vue&type=script&lang=js"

import "./Tutoriales.vue?vue&type=style&index=0&id=ca4ce25a&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4ce25a"]])

export default __exports__